import script from "./MiqaatProcurementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MiqaatProcurementForm.vue?vue&type=script&setup=true&lang=js"

import "./MiqaatProcurementForm.vue?vue&type=style&index=0&id=0c6640f5&lang=css"

const __exports__ = script;

export default __exports__